import React, { useState, useEffect } from "react";
import UserList from "../../components/UserList";
import AdminUserOverview from "../../components/AdminUserOverview";
import AddAdminUser from "../../components/AddAdminUser";
import Dialog from "../../components/Dialog/Dialog";

const Users = () => {
  // Mock data for demo purposes
  const mockUsers = [
    {
      id: 1,
      first_name: "Admin",
      middle_name: "",
      last_name: "User",
      role: "admin",
    },
    {
      id: 2,
      first_name: "John",
      middle_name: "Doe",
      last_name: "Smith",
      role: "teacher",
    },
    {
      id: 3,
      first_name: "Jane",
      middle_name: "",
      last_name: "Williams",
      role: "accountant",
    },
  ];

  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    // Format the mock users data
    const formattedUsers = mockUsers.map((user) => ({
      id: user.id,
      name: `${user.first_name} ${user.middle_name} ${user.last_name}`,
      role: user.role,
    }));
    setUsers(formattedUsers);
  }, []);

  const handleView = (user) => {
    setSelectedUser({
      id: user.id,
      firstName: user.name.split(" ")[0], // Extracting first name
      middleName: user.name.split(" ")[1] || "", // Extracting middle name
      lastName: user.name.split(" ")[2] || "", // Extracting last name
      role: user.role,
    });
  };

  const handleAdd = (newUser) => {
    // Generate a new ID
    const newId =
      users.length > 0 ? Math.max(...users.map((u) => u.id)) + 1 : 1;

    const addedUser = {
      ...newUser,
      id: newId,
      name: `${newUser.firstName} ${newUser.middleName} ${newUser.lastName}`,
    };

    setUsers([...users, addedUser]);

    // Also add to mockUsers for consistency
    mockUsers.push({
      id: newId,
      first_name: newUser.firstName,
      middle_name: newUser.middleName,
      last_name: newUser.lastName,
      role: newUser.role,
    });
  };

  const handleUpdate = (updatedUser) => {
    setUsers(
      users.map((user) => {
        if (user.id === updatedUser.id) {
          return {
            ...user,
            name: `${updatedUser.firstName} ${updatedUser.middleName} ${updatedUser.lastName}`,
            role: updatedUser.role,
          };
        }
        return user;
      })
    );

    // Also update mockUsers for consistency
    const index = mockUsers.findIndex((u) => u.id === updatedUser.id);
    if (index !== -1) {
      mockUsers[index] = {
        id: updatedUser.id,
        first_name: updatedUser.firstName,
        middle_name: updatedUser.middleName,
        last_name: updatedUser.lastName,
        role: updatedUser.role,
      };
    }
  };

  const handleDelete = (userId) => {
    setUsers(users.filter((user) => user.id !== userId));
    setSelectedUser(null);

    // Also remove from mockUsers for consistency
    const index = mockUsers.findIndex((u) => u.id === userId);
    if (index !== -1) {
      mockUsers.splice(index, 1);
    }
  };

  const handleClose = () => {
    setSelectedUser(null);
  };

  return (
    <div className="users-page">
      <UserList users={users} onView={handleView} />
      <div className="admin-side">
        <AddAdminUser onAdd={handleAdd} />
        {selectedUser && (
          <AdminUserOverview
            selectedUser={selectedUser}
            onDelete={handleDelete}
            onUpdate={handleUpdate}
            onClose={handleClose}
          />
        )}
      </div>
    </div>
  );
};

export default Users;
